function onKeyUpEscape(event) {
    if (!event.code || event.code.toUpperCase() !== 'ESCAPE') {
        return;
    }

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) {
        return;
    }
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.querySelectorAll('.skip-to-beginning-link').forEach(link => link.remove());

    if (elementToFocus) {
        elementToFocus.focus();
    }
}

function trapFocus(container, elementToFocus = container) {
    removeTrapFocus();

    // Creating a last focusable element ensures we never start focusing on browser native elements
    // until we removed the focus trap
    document.body.insertAdjacentHTML('beforeend', `
        <a class="skip-to-beginning-link button visually-hidden" href="#MainContent">Skip to beginning</a>
    `);

    trapFocusHandlers.focusin = event => {
        if (!container.contains(event.target)) {
            // If the element we just focused on is no longer inside our container we find the
            // first focusable element inside our container, and then we move the focus to it
            const firstFocusable = container.querySelector(
                "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
            );
            // Our container should always have at least one focusable,
            // but in case something goes wrong or the first focusable is hidden we allow the focus to move on
            if (firstFocusable && firstFocusable.getBoundingClientRect().width > 0) {
                firstFocusable.focus();
            } else {
                elementToFocus.focus();
            }
        }
    };

    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', () => mouseClick = true);

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

// eslint-disable-next-line no-unused-vars
function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true});

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    const count = selector.options.length;
    for (let i = 0; i < count; i++) {
        let option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function () {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                opt = document.createElement('option');
                opt.value = provinces[i][0];
                // eslint-disable-next-line no-unsanitized/property
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerText = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(
            summary => summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
        this.querySelectorAll('[data-submenu-close]').forEach(
            button => button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );

        this.querySelectorAll('[data-menu-close]').forEach(button => {
            button.addEventListener('click', event => {
                this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
            });
        });
    }

    onKeyUp(event) {
        if (!event.code || event.code.toUpperCase() !== 'ESCAPE') {
            return;
        }

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) {
            return;
        }

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) {
                event.preventDefault();
                this.closeMenuDrawer(event, summaryElement);
            } else {
                this.openMenuDrawer(summaryElement);
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        }, 5);
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) {
            return;
        }

        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {
                this.closeMenuDrawer();
            }
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        setTimeout(() => {
            if (detailsElement.open) {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }, 250);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();

        this.dataset.initialized = 'true';
    }

    // Part of the following code is duplicated in header-drawer.liquid to ensure the menu can always be opened
    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.header.classList.add('menu-open');

        setTimeout(() => this.mainDetailsToggle.classList.add('menu-opening'));

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (event) => {
            if (event.code && event.code.toUpperCase() === 'ESCAPE') {
                this.hide();
            }
        });

        this.addEventListener('click', (event) => {
            if (event.target === this) {
                if (!this.hasAttribute('data-prevent-self-close')) {
                    this.hide();
                }

                return;
            }

            if (
                event.target.closest('[id^="ModalClose-"]')
                || (event.target.id || '').includes('ModalClose-')
            ) {
                this.hide();
            }
        });
    }

    connectedCallback() {
        if (this.moved || this.dataset.unmovable) {
            return;
        }

        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.opener = opener;
        const popup = this.querySelector('.template-popup');
        this.setAttribute('open', '');
        if (popup) {
            popup.loadContent();
        }
        window.pauseAllMedia();
        this.focus();

        if (this.dataset.animated) {
            this.querySelector('[role="dialog"]').style.transition = `transform ${this.dataset.animationDuration || 300}ms`;
            setTimeout(() => this.classList.add('animate'));
        }

        if (this.dataset.contentUrl) {
            this.fetchAjaxContent(this.dataset.contentUrl)
                .then(html => this.renderAjaxContent(html))
                .catch(error => this.renderAjaxError(error));
        }
        this.dispatchEvent(new CustomEvent('modalDialogShown', {bubbles: true}));
    }

    focus() {
        if (!this.dataset.bodyOverflowVisible || BryanAnthonys.device.isMobile()) {
            document.body.classList.add('overflow-hidden');
        }
        trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    hide(forceClose = false) {
        if (!forceClose && this.dataset.animated && this.classList.contains('animate')) {
            this.classList.remove('animate');
            setTimeout(() => this.hide(), (this.dataset.animationDuration || 300) - 100);

            return;
        }

        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        window.pauseAllMedia();
        document.dispatchEvent(new CustomEvent('modalDialogHidden', {detail: {id: this.id}}));
        this.blur();

        if (this.dataset.scope) {
            const scopeElement = document.getElementById(this.dataset.scope);
            if (scopeElement && scopeElement.hasAttribute('open')) {
                const trapInstantly = scopeElement.id === 'CartDrawer';

                scopeElement.focus(trapInstantly);
            }
        }

        this.dispatchEvent(new CustomEvent('modalDialogHidden', {bubbles: true}));
    }

    blur() {
        removeTrapFocus(this.opener);
        document.body.classList.remove('overflow-hidden');
    }

    renderAjaxContent(html) {
        const placeholder = this.querySelector('[data-modal-loading]');
        if (placeholder) {
            if (this.dataset.contentElement) {
                const ajaxDocument = new DOMParser().parseFromString(html, 'text/html');
                const contentElement = ajaxDocument.querySelector(this.dataset.contentElement);
                html = contentElement ? contentElement.innerHTML : '';
            }

            placeholder.insertAdjacentHTML('beforebegin', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(html)));
            placeholder.remove();
        }
    }

    renderAjaxError(error) {
        console.error(error);
        const placeholder = this.querySelector('[data-modal-loading]');
        if (placeholder) {
            // eslint-disable-next-line no-unsanitized/method
            placeholder.insertAdjacentHTML('beforebegin', `
                <div class="status-banner status-banner--error">${BryanAnthonys.strings.general.genericAjaxError}</div>
            `);
            placeholder.remove();
        }
    }

    fetchAjaxContent(url) {
        ModalDialog.ajaxCache = ModalDialog.ajaxCache || {};

        return new Promise(function (resolve, reject) {
            if (typeof ModalDialog.ajaxCache[url] !== 'undefined') {
                resolve(ModalDialog.ajaxCache[url]);

                return;
            }

            fetch(url)
                .then(BryanAnthonys.decodeTextResponse)
                .then(html => {
                    ModalDialog.ajaxCache[url] = html;
                    resolve(html);
                })
                .catch(reject);
        });
    }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) {
                modal.show(button);
            }
        });
    }
}

customElements.define('modal-opener', ModalOpener);

document.querySelectorAll('footer [href="/pages/jewelry-care"]').forEach(jewelryCareLink => {
    jewelryCareLink.addEventListener('click', function (e) {
        e.preventDefault();

        const jewelryCareModal = document.getElementById('JewelryCareModal');
        if (jewelryCareModal) {
            jewelryCareModal.show(jewelryCareLink);
        }
    });
});

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) {
            return;
        }
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) {
                deferredElement.focus();
            }
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    initialize() {
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.scrollbar = this.querySelector('slider-scrollbar');

        if (['auto', 'always'].includes(this.dataset.freeScroll)) {
            this.slider.classList.add('slider--free-scroll');
        }

        if (!this.slider || !this.nextButton) {
            return;
        }

        this.initPages();
        const resizeObserver = new ResizeObserver(() => this.initPages());
        resizeObserver.observe(this.slider);
        document.addEventListener('tabSelected', event => {
            const tabContentSelector = `#${event.detail.tab.getAttribute('aria-controls')}`;
            if (this.closest(tabContentSelector)) {
                setTimeout(() => this.initPages(), 20);
            }
        });

        this.interactedWithArrowButtons = false;
        this.slider.addEventListener('scroll', () => {
            this.update();
            if (
                !this.interactedWithArrowButtons
                && this.dataset.freeScroll
                && !this.classList.contains('slider-component--arrows-hidden-mobile')
            ) {
                this.classList.add('slider-component--arrows-hidden-mobile');
            }
        }, {passive: true});
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

        if (this.dataset.preloadNextImage === 'pdp-gallery') {
            this.enableNextSlideImagePreloading('.product__media img[loading="lazy"]');
        } else if (this.dataset.preloadNextImage === 'grid-slider') {
            this.enableNextSlideImagePreloading('[data-slide-media] img[loading="lazy"]');
        }
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) {
            return;
        }
        // number of pixels per slide used as a buffer when calculating the number of visible slides per page
        const buffer = 3;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / (this.sliderItemOffset - buffer)
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();

        if (this.dataset.hasMediaSlides && this.getFirstSlideMedia() && this.getFirstSlideMedia().offsetHeight) {
            this.classList.add('slider-component-arrows-positioned');
            const buttonsTop = Math.round(
                (this.getFirstSlideMedia().offsetHeight / 2) - (this.nextButton.offsetHeight / 2)
            );
            this.nextButton.parentElement.style.top = `${buttonsTop}px`;
        }
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        // Temporarily prevents unneeded updates resulting from variant changes
        // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
        if (!this.slider || !this.nextButton) {
            return;
        }

        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage !== previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1]
                }
            }));
        }

        if (this.scrollbar) {
            this.scrollbar.updateScrollPosition();
        }

        if (this.enableSliderLooping) {
            return;
        }

        if (this.prevButton && this.isSlideVisible(this.sliderItemsToShow[0])) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else if (this.prevButton) {
            this.prevButton.removeAttribute('disabled');
        }

        const lastSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
        if (this.nextButton && this.isSlideVisible(lastSlide, 1)) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else if (this.nextButton) {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        // number of pixels from the beginning of slider to the rightmost visible pixel +- offset
        const sliderRightVisibleLimit = this.slider.clientWidth + this.slider.scrollLeft + offset;
        // number of pixels from the beginning of slider to the leftmost visible pixel +- offset
        const sliderLeftVisibleLimit = this.slider.scrollLeft - offset;
        // number of pixels from the beginning of slider until the element starts
        const elementStartsAt = element.offsetLeft;
        // number of pixels from the beginning of slider until the element ends
        const elementEndsAt = element.offsetLeft + element.clientWidth;

        return elementStartsAt >= sliderLeftVisibleLimit && elementEndsAt <= sliderRightVisibleLimit;
    }

    onButtonClick(event) {
        event.preventDefault();

        this.interactedWithArrowButtons = true;

        if (this.slider.classList.contains('slider--free-scroll') && this.dataset.freeScroll === 'auto') {
            this.slider.classList.remove('slider--free-scroll');
        }

        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next'
            ? this.slider.scrollLeft + (step * this.sliderItemOffset)
            : this.slider.scrollLeft - (step * this.sliderItemOffset);
        this.slider.scrollTo({
            left: this.slideScrollPosition < 0 ? 0 : this.slideScrollPosition
        });
    }

    scrollToFirstSlide() {
        this.slideScrollPosition = 0;
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    getFirstSlideMedia() {
        if (!this.firstSlideMedia && this.sliderItemsToShow[0]) {
            this.firstSlideMedia = this.sliderItemsToShow[0].querySelector('[data-slide-media]');
        }

        return this.firstSlideMedia;
    }

    enableNextSlideImagePreloading(imageSelector) {
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
            if (!entries[0].isIntersecting) {
                return;
            }

            const slide = entries[0].target;
            observer.unobserve(slide);

            let nextSlide = null;
            for (let checkedSlides = 0; checkedSlides < 6; checkedSlides++) {
                nextSlide = nextSlide ? nextSlide.nextElementSibling : slide.nextElementSibling;
                if (!nextSlide || (nextSlide && nextSlide.clientWidth > 0)) {
                    break;
                }
            }

            if (!nextSlide) {
                return;
            }

            const image = nextSlide.querySelector(imageSelector);
            if (image) {
                image.loading = 'eager';
            }
        });

        this.sliderItems.forEach(slide => intersectionObserver.observe(slide));
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    initialize() {
        super.initialize();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) {
            return;
        }

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) {
            this.currentPage = 1;
        }

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));

        if (this.slider.getAttribute('data-autoplay') === 'true') {
            this.setAutoPlay();
        }
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) {
            return;
        }

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderItemsToShow[0].clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');

        this.setSlideVisibility();

        if (!this.sliderControlButtons.length) {
            return;
        }

        this.sliderControlButtons.forEach(link => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) {
            return;
        }
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', BryanAnthonys.strings.accessibility.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', BryanAnthonys.strings.accessibility.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length
            ? 0
            : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const linkElements = item.querySelectorAll('a');
            if (index === this.currentPage - 1) {
                if (linkElements.length) linkElements.forEach(button => {
                    button.removeAttribute('tabindex');
                });
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (linkElements.length) linkElements.forEach(button => {
                    button.setAttribute('tabindex', '-1');
                });
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class SliderScrollbar extends HTMLElement {
    connectedCallback() {
        this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.mouseUpHandler = this.mouseUpHandler.bind(this);
        this.initialize = this.initialize.bind(this);
        this.setScrollbarWidth = this.setScrollbarWidth.bind(this);
        SliderScrollbar.draggingTimer = null;

        this.addEventListener('click', event => {
            if (!event.target.hasAttribute('data-handle')) {
                this.moveHandleToCursor(event.clientX);
            }
        });

        this.addEventListener('mousedown', event => {
            if (event.target.hasAttribute('data-handle')) {
                this.active = true;
                document.body.classList.add('dragging-slider-scrollbar');
                document.addEventListener('mousemove', this.mouseMoveHandler);
                document.addEventListener('mouseup', this.mouseUpHandler);
                clearTimeout(SliderScrollbar.draggingTimer);
                SliderScrollbar.draggingTimer = setTimeout(
                    () => document.body.classList.remove('dragging-slider-scrollbar'),
                    9000
                );
            }
        });

        window.addEventListener('resize', BryanAnthonys.debounce(this.setScrollbarWidth, 200));

        setTimeout(this.setScrollbarWidth, 50);

        document.addEventListener('tabSelected', event => {
            const tabContentSelector = `#${event.detail.tab.getAttribute('aria-controls')}`;
            if (this.closest(tabContentSelector)) {
                setTimeout(this.setScrollbarWidth, 100);
            }
        });
    }

    initialize() {
        this.initialized = true;

        this.handle = this.querySelector('[data-handle]');
        this.track = this.querySelector('[data-track]');
        this.trackRectangle = this.track.getBoundingClientRect();
        this.slider = this.closest('slider-component');
        const lastSlide = this.slider.sliderItemsToShow[this.slider.sliderItemsToShow.length - 1];
        if (lastSlide) {
            const lastSlideRectangle = lastSlide.getBoundingClientRect();
            this.sliderTotalWidth = lastSlideRectangle.left + lastSlideRectangle.width - this.slider.getBoundingClientRect().left;
        } else {
            // this situation would only occur for hidden sliders (like the ones in tabs)
            this.sliderTotalWidth = this.slider.offsetWidth;
        }
    }

    mouseMoveHandler(event) {
        this.moveHandleToCursor(event.clientX);
    }

    mouseUpHandler() {
        this.active = false;
        document.removeEventListener('mousemove', this.mouseMoveHandler);
        document.removeEventListener('mouseup', this.mouseUpHandler);
        document.body.classList.remove('dragging-slider-scrollbar');
        clearTimeout(SliderScrollbar.draggingTimer);
    }

    moveHandleToCursor(mouseClientX) {
        if (!this.initialized) {
            this.initialize();
        }

        const leftOffset = mouseClientX - this.trackRectangle.left;
        const maxLeft = this.trackRectangle.width - this.handle.offsetWidth - 1;
        let left = Math.max(0, leftOffset - this.handle.offsetWidth / 2);
        if (left > maxLeft) {
            left = maxLeft;
        }

        this.handle.style.left = `${left}px`;

        let percentageToScroll = 0;
        if (this.handle.offsetLeft > 0) {
            const totalWidth = this.trackRectangle.width - this.handle.offsetWidth;
            percentageToScroll = (this.handle.offsetLeft) / totalWidth;
            percentageToScroll = Math.round(percentageToScroll * 100);
        }

        // accounting for rounding errors
        if (percentageToScroll > 98) {
            percentageToScroll = 100;
        }

        this.slider.slider.scrollLeft = (this.sliderTotalWidth - this.slider.offsetWidth) * (percentageToScroll / 100);
    }

    updateScrollPosition() {
        if (this.active) {
            return;
        }

        if (!this.initialized) {
            this.initialize();
        }

        const percentageScrolled = (this.slider.slider.scrollLeft / (this.sliderTotalWidth - this.slider.offsetWidth));
        const maxLeft = this.trackRectangle.width - this.handle.offsetWidth - 1;
        let left = percentageScrolled * maxLeft;
        if (left > maxLeft) {
            left = maxLeft;
        }

        this.handle.style.left = `${left}px`;
    }

    setScrollbarWidth() {
        this.initialize();
        this.classList.add('slider-scrollbar--initialized');
        const percentageWidth = Math.round((this.slider.offsetWidth / this.sliderTotalWidth) * 100);
        // checking to see if all slides are already visible. using 98 instead of 100 to account for rounding errors
        if (percentageWidth > 98) {
            this.style.visibility = 'hidden';
        } else {
            this.style.visibility = 'visible';
            this.handle.style.width = `${percentageWidth}%`;
        }

        this.updateScrollPosition();
    }
}

customElements.define('slider-scrollbar', SliderScrollbar);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        let observedElement = this;

        const extraCollectionElement = document.querySelector('[data-extra-collection]');
        if (extraCollectionElement) {
            observedElement = extraCollectionElement;
        }

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) {
                return;
            }

            observer.unobserve(observedElement);

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(responseText => {
                    const responseDom = new DOMParser().parseFromString(responseText, 'text/html');
                    const recommendations = responseDom.querySelector('product-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        // eslint-disable-next-line no-unsanitized/property
                        this.innerHTML = recommendations.innerHTML;
                    }

                    if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                        this.remove();
                    }

                    if (responseDom.querySelector('.grid__item')) {
                        this.classList.add('product-recommendations--loaded');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(observedElement);
    }
}

customElements.define('product-recommendations', ProductRecommendations);

class TabList extends HTMLElement {
    initialize() {
        this.tabs = this.querySelectorAll('[role="tab"]');
        this.tabs.forEach(tab => tab.addEventListener('keydown', this.handleKeyDown.bind(this)));
        this.addEventListener('click', this.handleTabClick.bind(this));
    }

    selectTab(tab, focus = false) {
        this.tabs.forEach(tab => {
            tab.tabIndex = -1;
            tab.setAttribute('aria-selected', 'false');
            tab.classList.remove('tab-button--active');
        });

        this.getTabPanels().forEach(tabPanel => tabPanel.classList.add('hidden'));

        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        tab.classList.add('tab-button--active');

        const tabPanel = document.getElementById(tab.getAttribute('aria-controls'));
        tabPanel.classList.remove('hidden');

        if (focus) {
            tab.focus();
        }

        this.dispatchEvent(new CustomEvent('tabSelected', {
            detail: {tab},
            bubbles: true
        }));
    }

    handleTabClick(event) {
        const tab = event.target.getAttribute('role') === 'tab'
            ? event.target
            : event.target.closest('[role="tab"]');

        if (tab) {
            this.selectTab(tab);
        }
    }

    handleKeyDown(event) {
        const tab = event.currentTarget;
        let switchedTab = false;

        switch (event.key) {
            case 'ArrowLeft':
                if (tab.previousElementSibling && tab.previousElementSibling.getAttribute('role') === 'tab') {
                    this.selectTab(tab.previousElementSibling, true);
                } else {
                    this.selectTab(this.tabs[this.tabs.length - 1], true);
                }
                switchedTab = true;
                break;

            case 'ArrowRight':
                if (tab.nextElementSibling && tab.nextElementSibling.getAttribute('role') === 'tab') {
                    this.selectTab(tab.nextElementSibling, true);
                } else {
                    this.selectTab(this.tabs[0], true);
                }
                switchedTab = true;
                break;

            case 'Home':
                this.selectTab(this.tabs[0]);
                switchedTab = true;
                break;

            case 'End':
                this.selectTab(this.tabs[this.tabs.length - 1]);
                switchedTab = true;
                break;

            default:
                break;
        }

        if (switchedTab) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    getTabPanels() {
        return Array.from(this.tabs)
            .map(button => document.getElementById(button.getAttribute('aria-controls')));
    }
}

customElements.define('tab-list', TabList);

class StickyHeader extends HTMLElement {
    connectedCallback() {
        this.topOffset = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onKeyUpEscape = this.onKeyUpEscape.bind(this);
        this.setTopOffset = this.setTopOffset.bind(this);
        window.addEventListener('scroll', this.onScroll, {passive: true});
        window.addEventListener('keyup', this.onKeyUpEscape);
        window.addEventListener('resize', BryanAnthonys.debounce(this.setTopOffset, 100));
        document.addEventListener('DOMContentLoaded', () => {
            this.setTopOffset();
            this.onScroll();
        });
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
    }

    setTopOffset() {
        this.topOffset = 0;
        const announcements = document.querySelector('[data-announcements]');
        if (announcements) {
            if (BryanAnthonys.device.isMobile()) {
                this.topOffset += parseInt(announcements.dataset.heightMobile);
            } else {
                this.topOffset += parseInt(announcements.dataset.heightDesktop);
            }
        }
    }

    onScroll() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > this.topOffset) {
            document.body.classList.add('body--with-sticky-header');
        } else {
            document.body.classList.remove('body--with-sticky-header');
        }
    }

    onKeyUpEscape(event) {
        if (!event.code || event.code.toUpperCase() !== 'ESCAPE') {
            return;
        }

        this.querySelectorAll('details[data-opened-on-hover]').forEach(details => {
            details.removeAttribute('open');
            details.removeAttribute('data-opened-on-hover');
        });
    }
}

customElements.define('sticky-header', StickyHeader);

class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) {
                this.close();
            }
        });
    }

    onToggle() {
        this.animations = this.content.getAnimations();

        if (this.mainDetailsToggle.hasAttribute('open')) {
            this.animations.forEach(animation => animation.play());
        } else {
            this.animations.forEach(animation => animation.cancel());
        }
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
    connectedCallback() {
        this.menu = this.closest('ul');
        this.header = document.querySelector('.header-wrapper');

        if (!BryanAnthonys.device.hasTouchscreen()) {
            const delayTime = 150;

            let delay = null;

            this.addEventListener('mouseenter', () => {
                clearTimeout(delay);
                delay = setTimeout(() => {
                    this.mainDetailsToggle.setAttribute('open', '');
                    this.mainDetailsToggle.setAttribute('data-opened-on-hover', 'yes');
                }, delayTime);
            });

            this.addEventListener('mouseleave', () => {
                clearTimeout(delay);
                delay = setTimeout(() => {
                    if (this.mainDetailsToggle.hasAttribute('data-opened-on-hover')) {
                        this.close();
                    }
                }, delayTime);
            });

            const summary = this.mainDetailsToggle.querySelector('summary');

            summary.addEventListener('click', event => {
                // If the dropdown was open on hover, we prevent its closing on click
                if (
                    this.mainDetailsToggle.hasAttribute('open')
                    && this.mainDetailsToggle.hasAttribute('data-opened-on-hover')
                ) {
                    event.preventDefault();
                    summary.classList.add('header__menu-item--animate-caret');
                    setTimeout(() => {
                        summary.classList.remove('header__menu-item--animate-caret');
                    }, 1000);
                }
            });
        }
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        this.mainDetailsToggle.removeAttribute('data-opened-on-hover');
    }
}

customElements.define('header-menu', HeaderMenu);

class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => {
                if (event.code && event.code.toUpperCase() === 'ESCAPE') {
                    this.close();
                }
            }
        );
        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );
        this.querySelector('button[type="button"]').addEventListener(
            'click',
            this.close.bind(this)
        );

        this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest('details').hasAttribute('open')
            ? this.close()
            : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event) {
        this.onBodyClickEvent =
            this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        if (!this.dataset.bodyOverflowVisible || BryanAnthonys.device.isMobile()) {
            document.body.classList.add('overflow-hidden');
        }

        trapFocus(
            this.detailsContainer.querySelector('[tabindex="-1"]'),
            this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
    }

    close(focusToggle = true) {
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.detailsContainer.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
    }
}

customElements.define('details-modal', DetailsModal);

class AnnouncementBar extends HTMLElement {
    connectedCallback() {
        this.announcementSlides = document.querySelectorAll('[data-announcement-slide]');
        this.changeAnnouncementSlide = this.changeAnnouncementSlide.bind(this);
        if (this.announcementSlides.length > 1) {
            const changeInterval = parseInt(this.dataset.slideInterval) * 1000;
            setInterval(this.changeAnnouncementSlide, changeInterval);

            if (BryanAnthonys.device.hasTouchscreen()) {
                let touchStartX;

                this.addEventListener('touchstart', event => {
                    touchStartX = event.changedTouches[0].screenX;
                }, false);

                this.addEventListener('touchend', event => {
                    const horizontalDiff = touchStartX - event.changedTouches[0].screenX;
                    if (Math.abs(horizontalDiff) > 100) {
                        this.changeAnnouncementSlide();
                    }
                }, false);
            }
        }

        if (this.announcementSlides.length) {
            this.announceCartChanges();
        }

        this.shippingMessages = this.querySelectorAll('[data-replace-with-free-shipping]');
        if (this.shippingMessages.length) {
            document.addEventListener('freeShippingComputed', event => {
                if (
                    (!event.detail.unlocked && !event.detail.progress)
                    || !event.target.closest('#CartDrawer')
                ) {
                    return;
                }

                const textElement = event.target.querySelector('[data-progress-text]');
                if (textElement) {
                    this.shippingMessages.forEach(message => {
                        message.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(
                            `<span class="uppercase letter-spacing-1">${textElement.innerHTML}</span>`
                        ));
                    });
                }
            });
        }
    }

    announceCartChanges() {
        document.addEventListener('itemAddedToCart', () => {
            setTimeout(() => this.changeNavTeaser(BryanAnthonys.strings.cart.itemAddedToCart), 2000);
        });
        document.addEventListener('changedCartItem', () => {
            this.changeNavTeaser(BryanAnthonys.strings.cart.changedCartItem);
        });
        document.addEventListener('updatedCart', () => {
            this.changeNavTeaser(BryanAnthonys.strings.cart.updatedCart);
        });
        document.addEventListener('itemAddedToWishlist', () => {
            this.changeNavTeaser(BryanAnthonys.strings.wishlist.added);
        });
        document.addEventListener('itemRemovedFromWishlist', () => {
            this.changeNavTeaser(BryanAnthonys.strings.wishlist.removed);
        });
        document.addEventListener('productListCardsRendered', () => {
            this.changeNavTeaser(BryanAnthonys.strings.general.additionalProductsAdded);
        });
    }

    changeAnnouncementSlide() {
        if (this.dataset.paused) {
            return;
        }

        let setNewSlide = false;
        let unsetOldSlide = false;

        this.announcementSlides.forEach(function (announcementSlide) {
            if (announcementSlide.classList.contains('announcement-slide--visible')) {
                announcementSlide.classList.remove('announcement-slide--visible');
                unsetOldSlide = true;
            } else if (!setNewSlide && unsetOldSlide) {
                announcementSlide.classList.add('announcement-slide--visible');
                setNewSlide = true;
            }
        });

        if (!setNewSlide) {
            this.announcementSlides[0].classList.add('announcement-slide--visible');
        }
    }

    changeNavTeaser(content) {
        const visibleAnnouncement = document.querySelector('.announcement-slide--visible');
        if (!visibleAnnouncement) {
            return;
        }

        const notices = visibleAnnouncement.querySelector('.announcement-slide__notices');
        if (!notices) {
            return;
        }

        visibleAnnouncement.classList.add('announcement-slide--notice-visible');
        notices.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(content));
        this.setAttribute('data-paused', 'true');
        setTimeout(() => {
            visibleAnnouncement.classList.remove('announcement-slide--notice-visible');
            notices.innerHTML = '';
            this.removeAttribute('data-paused');
        }, 10000);
    }
}

customElements.define('announcement-bar', AnnouncementBar);

class FooterBlock extends HTMLElement {
    initialize() {
        this.toggleCollapsibles = this.toggleCollapsibles.bind(this);
        window.addEventListener('resize', BryanAnthonys.debounce(this.toggleCollapsibles, 100));
        this.toggleCollapsibles();
    }

    toggleCollapsibles() {
        const detailsList = this.querySelectorAll('details');
        detailsList.forEach(details => {
            if (BryanAnthonys.device.isMobile()) {
                details.removeAttribute('open');
                details.classList.remove('disabled');
            } else {
                details.setAttribute('open', '');
                details.classList.add('disabled');
            }
        });
    }
}

customElements.define('footer-block', FooterBlock);

class ProductCard extends HTMLElement {
    connectedCallback() {
        this.addEventListener('swatchButtonsVariantChanged', event => {
            if (event.detail.variant) {
                this.handleVariantChange(event.detail.product, event.detail.variant, event.detail.fullProduct);
            }
        });

        this.addEventListener('swatchButtonsFirstClicked', event => {
            this.updateImage(event.detail.variantImage);
        });
    }

    handleVariantChange(product, variant, fullProduct) {
        if (variant.featured_image) {
            this.updateImage(variant.featured_image.src);
        }

        if (variant.option1) {
            const selectedFinish = variant.option1;

            const allSpecificBadges = this.querySelectorAll('[data-finish]');
            allSpecificBadges.forEach(badge => {
                badge.classList.add('hidden');
            });

            const visibleSpecificBadges = this.querySelectorAll(`[data-finish="${selectedFinish}"]`);
            visibleSpecificBadges.forEach(badge => {
                badge.classList.remove('hidden');
            });
        }

        this.querySelectorAll('[data-product-card-link]').forEach(productLink => {
            const url = new URL(productLink.href);
            url.searchParams.set('variant', variant.id);
            productLink.href = url;
        });

        this.updateSecondImage(fullProduct.variants_media[variant.id]);
    }

    updateImage(imageSrc) {
        const cardImage = this.querySelector('[data-product-card-image]');
        if (cardImage) {
            const imageWidth = new URLSearchParams(cardImage.src.split('?')[1]).get('width');
            cardImage.removeAttribute('srcset');
            cardImage.removeAttribute('sizes');
            cardImage.src = BryanAnthonys.resizeImage(imageSrc, parseInt(imageWidth));

            const cardMediaSlider = this.querySelector('card-media-slider');
            if (cardMediaSlider) {
                cardMediaSlider.scrollLeft = 0;
            }
        }
    }

    updateSecondImage(additionalVariantMedia) {
        if (!additionalVariantMedia || !additionalVariantMedia.length) {
            return;
        }

        const secondImage = additionalVariantMedia.find(media => media.media_type === 'image');
        if (!secondImage) {
            return;
        }

        const cardSecondImage = this.querySelector('[data-product-card-additional-image]');
        if (!cardSecondImage) {
            return;
        }

        const existingImage = this.querySelector(`card-media-slider [src*="${secondImage.src}"]`);
        if (existingImage) {
            this.swapSecondVariantImage(existingImage);

            return;
        }

        const imageWidth = new URLSearchParams(cardSecondImage.src.split('?')[1]).get('width');
        cardSecondImage.removeAttribute('srcset');
        cardSecondImage.removeAttribute('sizes');
        cardSecondImage.src = BryanAnthonys.resizeImage(secondImage.src, parseInt(imageWidth));
        if (secondImage.alt) {
            cardSecondImage.alt = secondImage.alt;
        }
    }

    swapSecondVariantImage(existingImage) {
        const existingImageSlide = existingImage.closest('[data-slide]');

        const existingImageSlideIndex = Array.from(
            existingImageSlide.parentElement.children
        ).indexOf(existingImageSlide);

        if (existingImageSlideIndex != 2) {
            return;
        }

        const previousImage = existingImageSlide.previousElementSibling.querySelector('[data-product-card-additional-image]');

        existingImage.parentNode.replaceChild(previousImage.cloneNode(), existingImage);
        previousImage.parentNode.replaceChild(existingImage.cloneNode(), previousImage);
    }
}

customElements.define('product-card', ProductCard);

class CustomCardMedia extends HTMLElement {
    initialize() {
        if (this.hasAttribute('data-has-video')) {
            this.video = this.querySelector('video');
            if (this.video) {
                const isFirst = typeof this.video.dataset.isFirst !== 'undefined' ? 1 : 0;

                this.registerVideoIntersectionObserver();

                if (!isFirst && !BryanAnthonys.device.hasTouchscreen()) {
                    this.addEventListener('mouseenter', this.showVideo);
                    this.addEventListener('mouseleave', this.hideVideo);
                }
            }

            this.addEventListener('click', this.handleClicks);
        }
    }

    showVideo() {
        this.video.classList.remove('hidden');
    }

    hideVideo() {
        this.video.classList.add('hidden');
    }

    registerVideoIntersectionObserver() {
        new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    this.loadVideo();
                    this.video.play();
                } else {
                    this.video.pause();
                }
            });
        }).observe(this.video);
    }

    loadVideo() {
        const source = this.video.querySelector('source');

        if (!source.dataset.src || source.src) {
            return;
        }

        source.src = source.dataset.src;

        this.video.load();
    }

    handleClicks(event) {
        if ((event.target.nodeName.toLowerCase() === 'img' || event.target.nodeName.toLowerCase() === 'video')
            && event.target.parentElement.classList.contains('media')
        ) {
            this.parentElement.querySelector('.card-media-anchor').click();
        }
    }
}

customElements.define('custom-card-media', CustomCardMedia);

class CustomProductCardMedia extends CustomCardMedia {
    initialize() {
        super.initialize();

        const productCard = this.closest('product-card');

        if (productCard) {
            productCard.addEventListener('swatchButtonsVariantChanged', event => {
                if (event.detail.variant) {
                    this.updateImage(event.detail.variant);
                }
            });
        }
    }

    updateImage(variant) {
        const cardImage = this.querySelector('img');

        if (cardImage) {
            let imageSrc = this.getAttribute(`data-variant-image-${BryanAnthonys.handleize(variant.title)}`);

            if (!imageSrc) {
                imageSrc = this.dataset.defaultImage;
            }

            let imageAlt = this.getAttribute(`data-variant-image-alt-${BryanAnthonys.handleize(variant.title)}`);
            if (!imageAlt) {
                imageAlt = this.dataset.defaultImageAlt;
            }

            if (imageSrc) {
                cardImage.removeAttribute('srcset');
                cardImage.removeAttribute('sizes');
                cardImage.src = imageSrc;
                cardImage.alt = imageAlt;
            }
        }
    }
}

customElements.define('custom-product-card-media', CustomProductCardMedia);

class SwatchButtons extends HTMLElement {
    constructor() {
        super();
        this.productLoaded = false;
        this.activeSwatchClass = 'swatch-button--active';
    }

    connectedCallback() {
        this.addEventListener('click', event => {
            const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');
            if (button) {
                this.handleButtonClick(button);
            }
        });
    }

    handleButtonClick(button) {
        button.closest('swatch-group').querySelectorAll('button')
            .forEach(button => button.classList.remove(this.activeSwatchClass));
        button.classList.add(this.activeSwatchClass);

        if (button.dataset.variantImage && !this.productLoaded) {
            this.dispatchEvent(new CustomEvent('swatchButtonsFirstClicked', {
                detail: {variantImage: button.dataset.variantImage},
                bubbles: true
            }));
        }

        const activeOptionElement = button.closest('swatch-group').querySelector('[data-active-option]');
        if (activeOptionElement) {
            activeOptionElement.textContent = button.dataset.value;
        }

        this.getProduct(this.dataset.productHandle)
            .then(fullProduct => {
                this.productLoaded = true;
                const product = fullProduct.product;
                const options = this.getSelectedOptions();
                const variant = this.getVariantForOptions(product.variants, options);
                this.dataset.variantId = variant ? variant.id : '';
                this.dispatchEvent(new CustomEvent('swatchButtonsVariantChanged', {
                    detail: {product, variant, options, fullProduct},
                    bubbles: true
                }));
            })
            .catch(error => {
                console.error(error);
                this.dataset.variantId = '';
            });
    }

    getProduct(handle) {
        if (!this.dataset.productJsonSelector) {
            return BryanAnthonys.getProduct(handle, 'full-json');
        }

        const productJsonElement = document.querySelector(this.dataset.productJsonSelector);
        let json = false;
        if (productJsonElement) {
            json = JSON.parse(productJsonElement.innerText);
        }

        return new Promise(function (resolve, reject) {
            if (json) {
                resolve(json);
            } else {
                reject("Product JSON doesn't exist");
            }
        });
    }

    getSelectedOptions() {
        const options = {};
        this.querySelectorAll(`button.${this.activeSwatchClass}`).forEach(swatch => {
            options[`option${swatch.dataset.position}`] = swatch.dataset.value;
        });

        return options;
    }

    getVariantForOptions(variants, options) {
        let variantsForOptions = variants.filter(variant => {
            for (const optionIndex in options) {
                if (options[optionIndex] !== variant[optionIndex]) {
                    return false;
                }
            }

            return true;
        });

        if (!variantsForOptions.length) {
            return null;
        }

        const firstAvailableVariant = variantsForOptions.find(variant => variant.available);

        return firstAvailableVariant ? firstAvailableVariant : variantsForOptions[0];
    }
}

customElements.define('swatch-buttons', SwatchButtons);

customElements.define('copyable-input', class extends HTMLElement {
    connectedCallback() {
        const id = `field-${Math.round(Math.random() * 1000000)}`;
        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div class="field">
              <input class="field__input style-guide__input" type="text" id="${id}" value="${this.getAttribute('value')}" readonly>
              <label class="field__label" for="${id}">${this.getAttribute('label')}</label>
            </div>
            <button class="copyable-input-button" type="button" aria-label="Copy">
                <svg class="icon icon-copy" aria-hidden="true" focusable="false">
                    <use href="#icon-copy" />
                </svg>
            </button>
        `));

        this.querySelector('button').addEventListener('click', () => {
            if (this.classList.contains('copied')) {
                return;
            }

            const input = this.querySelector('input');
            input.select();
            input.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(input.value);
            this.classList.add('copied');
            setTimeout(() => this.classList.remove('copied'), 500);
            BryanAnthonys.showToast('Copied!', 'success', 2000);
        });
    }
});

customElements.define('free-shipping-progress', class extends HTMLElement {
    initialize() {
        this.render();
        const bar = this.querySelector('[data-progress-bar]');

        this.dispatchEvent(new CustomEvent('freeShippingComputed', {
            detail: {
                target: this,
                unlocked: !bar,
                needed: bar ? bar.dataset.needed : 0,
                progress: bar ? parseInt(bar.dataset.progressPercentage) : 0
            },
            bubbles: true
        }));
    }

    render() {
        const cart = BryanAnthonys.cart.getCache();
        const threshold = this.getThreshold();
        if (!threshold) {
            return;
        }
        const needed = threshold - cart.total_price;
        if (needed <= 0) {
            const complete = this.querySelector('[data-progress-text-complete]');
            complete.classList.remove('hidden');
            complete.setAttribute('data-progress-text', '');

            return;
        }

        const filled = (cart.total_price * 100) / threshold;
        const neededMoney = BryanAnthonys.formatMoney(needed);

        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(`
          <span data-progress-text>${this.dataset.neededText.replace('{{ amount }}', neededMoney)}</span>
          <div
            class="drawer__free-shipping-bar block mt-2" aria-hidden="true" data-progress-bar
            data-progress-percentage="${filled}" data-needed="${neededMoney}"
          >
            <span class="drawer__free-shipping-filled block" style="width: ${filled}%">&nbsp;</span>
          </div>
        `);
    }

    getThreshold() {
        const threshold = BryanAnthonys.isDomesticVisitor()
            ? BryanAnthonys.freeShippingThresholdUs
            : BryanAnthonys.freeShippingThresholdIntl;

        return threshold * 100;
    }
});

class CardMediaSlider extends HTMLElement {
    initialize() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) {
            this.classList.add('card-media-slider--single-slide');

            return;
        }

        this.interacted = false;
        this.bullets = [];
        this.classList.add('card-media-slider--initialized');
        this.updateOnScroll = this.updateOnScroll.bind(this);
        this.handleClicks = this.handleClicks.bind(this);
        this.nextArrow = null;
        this.prevArrow = null;
        this.querySelectorAll('.media--hover-effect')
            .forEach(media => media.classList.remove('media--hover-effect'));

        this.addEventListener('click', this.handleClicks);
        this.addEventListener('scroll', BryanAnthonys.debounce(this.updateOnScroll, 10), {passive: true});
        this.addArrows();
        this.addBullets();
        this.updateOnScroll();
        this.autoScrollOnDesktopHover();
    }

    updateOnScroll() {
        this.classList.remove('card-media-slider--autoscroll');

        const [visibleSlideIndex] = this.getVisibleSlide(null);

        // do not change anything if the slider is transitioning
        if (visibleSlideIndex === null) {
            return;
        }

        if (this.nextArrow && visibleSlideIndex < (this.slides.length - 1)) {
            this.nextArrow.removeAttribute('disabled');
        } else if (this.nextArrow) {
            this.nextArrow.setAttribute('disabled', '');
        }

        if (this.prevArrow && visibleSlideIndex > 0) {
            this.prevArrow.removeAttribute('disabled');
        } else if (this.prevArrow) {
            this.prevArrow.setAttribute('disabled', '');
        }

        if (this.bullets.length) {
            this.bullets.forEach(bullet => bullet.classList.remove('card-media-slider__bullet--active'));
            this.bullets[visibleSlideIndex].classList.add('card-media-slider__bullet--active');
        }
    }

    getVisibleSlide(defaultTo = 0) {
        let visibleSlideIndex = defaultTo;
        const visibleSlide = this.slides.find((slide, index) => {
            if (this.isSlideVisible(slide)) {
                visibleSlideIndex = index;

                return true;
            }
        });

        return [visibleSlideIndex, visibleSlide];
    }

    isSlideVisible(element) {
        const lastVisibleSlide = this.clientWidth + this.scrollLeft + 5;

        return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide
            && element.offsetLeft >= (this.scrollLeft - 5);
    }

    handleClicks(event) {
        if (event.target.nodeName.toLowerCase() === 'img' && event.target.parentElement.classList.contains('media')) {
            this.querySelector('.card-media-anchor').click();
        }
    }

    addArrows() {
        if (BryanAnthonys.device.isMobile() || BryanAnthonys.device.hasTouchscreen()) {
            return;
        }

        this.parentElement.insertAdjacentHTML('beforeend', `
            <button 
                type="button" aria-hidden="true" tabindex="-1" data-slider-previous disabled
                class="card-media-slider__button card-media-slider__button--previous" aria-label="Previous image"
            >
                <svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-caret"/></svg>
            </button>
            <button 
                type="button" aria-hidden="true" tabindex="-1" data-slider-next disabled
                class="card-media-slider__button card-media-slider__button--next" aria-label="Next image"
            >
                <svg class="icon icon-caret" aria-hidden="true" focusable="false"><use href="#icon-caret"/></svg>
            </button>
       `);

        this.nextArrow = this.parentElement.querySelector('[data-slider-next]');
        this.prevArrow = this.parentElement.querySelector('[data-slider-previous]');

        [this.prevArrow, this.nextArrow].forEach(arrow => {
            arrow.addEventListener('click', () => {
                this.interacted = true;
                arrow.disabled = true;
                const [visibleSlideIndex] = this.getVisibleSlide();
                if (
                    arrow.hasAttribute('data-slider-next')
                    && typeof this.slides[visibleSlideIndex + 1] !== 'undefined'
                ) {
                    this.slideTo(visibleSlideIndex + 1);
                } else if (
                    arrow.hasAttribute('data-slider-previous')
                    && visibleSlideIndex > 0
                    && typeof this.slides[visibleSlideIndex - 1] !== 'undefined'
                ) {
                    this.slideTo(visibleSlideIndex - 1);
                }
            });
        });
    }

    addBullets() {
        if (!(BryanAnthonys.device.isMobile() || BryanAnthonys.device.hasTouchscreen())) {
            return;
        }

        const bullets = [];
        this.slides.forEach((slide, index) => {
            bullets.push(`
                <button 
                    type="button" data-index="${index}" data-slider-bullet aria-label="Scroll to image ${index + 1}"
                    class="card-media-slider__bullet"
                >&nbsp;</button>
            `);
        });

        this.parentElement.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(`
            <div class="card-media-slider__bullets" data-slider-bullets>
                ${bullets.join('')}
            </div>
        `));

        this.bullets = Array.from(this.parentElement.querySelectorAll('[data-slider-bullet]'));

        this.parentElement.querySelector('[data-slider-bullets]').addEventListener('click', event => {
            if (event.target.nodeName.toLowerCase() === 'button') {
                this.slideTo(event.target.dataset.index);
            }
        });
    }

    slideTo(index) {
        this.scrollTo({
            left: this.slides[index].offsetWidth * index
        });
    }

    autoScrollOnDesktopHover() {
        if (BryanAnthonys.device.isMobile() || BryanAnthonys.device.hasTouchscreen()) {
            return;
        }

        this.parentElement.addEventListener('mouseenter', () => {
            if (this.interacted) {
                return;
            }

            this.classList.add('card-media-slider--autoscroll');
            this.slideTo(1);
        });

        this.parentElement.addEventListener('mouseleave', () => {
            if (this.interacted) {
                return;
            }

            this.classList.add('card-media-slider--autoscroll');
            this.slideTo(0);
        });
    }
}

customElements.define('card-media-slider', CardMediaSlider);

class CrossSells extends SlideshowComponent {
    initialize() {
        super.initialize();
        this.handleCartOpen = this.handleCartOpen.bind(this);
        this.handleCartClose = this.handleCartClose.bind(this);
        this.pauseOnInteraction = this.pauseOnInteraction.bind(this);

        document.addEventListener('cartRendered', this.handleCartOpen);
        document.addEventListener('cartDrawerOpen', this.handleCartOpen);
        document.addEventListener('cartDrawerClosed', this.handleCartClose);

        if (!this.sliderItemsToShow.length) {
            this.classList.add('hidden');
        } else if (this.sliderItemsToShow.length === 1) {
            this.querySelector('[data-cross-sells-controls]').classList.add('hidden');
        }

        this.addEventListener('click', this.pauseOnInteraction);
        this.addEventListener('touchstart', this.pauseOnInteraction, {passive: true});
        this.addEventListener('keyup', this.pauseOnInteraction);
    }

    handleCartOpen() {
        if (!this.interacted) {
            this.autoplaySpeed = this.slider.dataset.speed * 1000;
            this.play();
        }
    }

    pauseOnInteraction() {
        this.interacted = true;
        this.pause();
    }

    handleCartClose() {
        this.pause();
    }

    disconnectedCallback() {
        document.removeEventListener('cartRendered', this.handleCartOpen);
        document.removeEventListener('cartDrawerOpen', this.handleCartOpen);
        document.removeEventListener('cartDrawerClosed', this.handleCartClose);
    }
}

customElements.define('cross-sells', CrossSells);

class CountdownClock extends HTMLElement {
    constructor() {
        super();
        this.updateClock = this.updateClock.bind(this);
        setTimeout(this.startClock.bind(this), 20);
    }

    startClock() {
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        if (!this.hours || !this.minutes || !this.seconds) {
            return;
        }
        this.setCountdownTo();
        if (isNaN(this.countdownTo)) {
            this.setClockAtZero();
            return;
        }
        this.updateClock();
        this.clockInterval = setInterval(this.updateClock, 1000);
        this.classList.add('countdown-clock--started');
    }

    updateClock() {
        const {total, seconds, minutes, hours} = this.getTimeRemaining();
        if (total < 0) {
            this.setClockAtZero();
            this.disableCountDown();

            return;
        }
        if (this.hours.innerText !== hours) {
            this.hours.innerText = hours;
        }
        if (this.minutes.innerText !== minutes) {
            this.minutes.innerText = minutes;
        }
        this.seconds.innerText = seconds;
    }

    setClockAtZero() {
        this.hours.innerText = '00';
        this.minutes.innerText = '00';
        this.seconds.innerText = '00';
    }

    getTimeRemaining() {
        const total = this.countdownTo - Date.now();
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor(total / (1000 * 60 * 60));

        return {
            total: total,
            seconds: seconds < 10 ? `0${seconds}` : `${seconds}`,
            minutes: minutes < 10 ? `0${minutes}` : `${minutes}`,
            hours: hours < 10 ? `0${hours}` : `${hours}`
        };
    }

    setCountdownTo() {
        if (this.dataset.reset === "daily") {
            const tomorrow = new Date();
            tomorrow.setHours(0);
            tomorrow.setMinutes(0);
            tomorrow.setSeconds(0);
            this.countdownTo = tomorrow.getTime() + (24 * 3600 * 1000);
        } else if (this.dataset.reset === "hourly") {
            this.countdownTo = this.getHourlyCountdownTo();
        }
    }

    getHourlyCountdownTo() {
        const storageKey = 'countdown-clock-cart-drawer';
        let storedUntil = localStorage.getItem(storageKey);
        const now = Date.now();
        if (!storedUntil || storedUntil < now) {
            storedUntil = now + (3598 * 1000);
            localStorage.setItem(storageKey, String(storedUntil));
        }

        return storedUntil;
    }

    disableCountDown() {
        if (this.clockInterval) {
            clearInterval(this.clockInterval);
        }
    }

    disconnectedCallback() {
        this.disableCountDown();
    }
}

customElements.define('countdown-clock', CountdownClock);

class CheckoutButton extends HTMLElement {
    initialize() {
        this.querySelector('a').addEventListener('click', event => {
            const cartDrawerSubmit = document.querySelector('#CartDrawer button[name="checkout"]');
            if (cartDrawerSubmit) {
                event.preventDefault();
                event.target.classList.add('loading');
                // in case the page gets stuck we remove the loading animation after 10 seconds
                setTimeout(() => event.target.classList.remove('loading'), 10000);
                cartDrawerSubmit.click();
            }
        });
    }
}

customElements.define('checkout-button', CheckoutButton);

class CustomerInputPreview extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', event => {
            if (this.hasAttribute('data-loading')) {
                event.preventDefault();
                return;
            }

            switch (this.dataset.type) {
                case 'personalized-frame':
                    event.preventDefault();
                    this.showPersonalizedFramePreview();

                    break;
                case 'engravable':
                    event.preventDefault();
                    this.showEngravablePreview();

                    break;
            }
        });
    }

    showPersonalizedFramePreview() {
        this.setAttribute('data-loading', 'true');
        BryanAnthonys.loadScript('personalized-frame-preview', {
            callback: () => {
                this.dataset.image = new URL(this.querySelector('a').getAttribute('href')).toString();
                BryanAnthonys.personalizedFramePreview.openModal(this, false, true);
                this.removeAttribute('data-loading');
            }
        });
    }

    showEngravablePreview() {
        this.setAttribute('data-loading', 'true');
        BryanAnthonys.loadScript('engravables', {
            callback: () => {
                BryanAnthonys.showEngravablePreview(
                    this.dataset.producthandle,
                    this.dataset.variantId,
                    new URL(this.querySelector('a').getAttribute('href')).toString()
                ).then(() => this.removeAttribute('data-loading'));
            }
        });
    }
}

customElements.define('customer-input-preview', CustomerInputPreview);

class UploadButton extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', event => {
            if (event.target.getAttribute('type') !== 'file') {
                this.querySelector('[type="file"]').click();
            }
        });
    }
}

customElements.define('upload-button', UploadButton);

class UrlSelector extends HTMLElement {
    constructor() {
        super();
        this.changeCallback = (url) => {
            window.location.href = url;
            return true;
        };
    }

    connectedCallback() {
        this.addEventListener('change', event => {
            const disable = this.changeCallback(event.target.value);
            if (disable) {
                event.target.disabled = true;
            }
        });
    }

    setChangeCallback(changeCallback) {
        this.changeCallback = changeCallback;
    }
}

customElements.define('url-selector', UrlSelector);

// This must remain as the last element in this file. Add new code above this.
// This element can only be used inside elements defined in this file.
class GlobalElementInitializer extends HTMLElement {
    connectedCallback() {
        if (typeof this.parentElement.initialize === 'function') {
            this.parentElement.initialize();
        }
    }
}

customElements.define('global-element-initializer', GlobalElementInitializer);